import React, { Component, Suspense } from "react";

import { Translation } from "react-i18next";

import "./TermCondition.scss";

class TermCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderButton: false,
      loggedIn: false,
      loading: true,
      statusUser: false,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div className="mpl-page cp-85">
        <Suspense fallback="...Loading">
          <Translation>
            {(t) => (
              <div className="container">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="page-wrapper">
                      <div className="page-content mt-2">
                        <div className="termspage program-tab-description">
                            <ul>
                              <li>
                                {t("TermCondition.p1")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p2")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p3")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p4")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p5")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p6")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p7")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p8")}
                                <br />
                                <br />
                              </li>
                              <li>
                                {t("TermCondition.p9")}
                                <br />
                                <br />
                              </li>
                            </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Translation>
        </Suspense>
      </div>
    );
  }
}
export default TermCondition;
